import { useCallback } from 'react';

import { AnalyticsEvent, useAnalytics } from '@bonusly/analytics';

import { CelebrationType } from '../../types';

export type CelebrationEventProps = {
	celebrationType: CelebrationType;
};

export const useTrackCelebrations = () => {
	const { track } = useAnalytics();

	const trackCelebrationLinkClick = useCallback(
		(eventProps: CelebrationEventProps) => {
			track(AnalyticsEvent.Celebrations.CelebrationLinkClick, {
				...eventProps,
			});
		},
		[track]
	);

	const trackCelebrationTooltipHover = useCallback(() => {
		track(AnalyticsEvent.Celebrations.CelebrationTooltipHover);
	}, [track]);

	const trackCelebrationModalLinkClick = useCallback(
		(eventProps: CelebrationEventProps) => {
			track(AnalyticsEvent.Celebrations.CelebrationModalLinkClick, {
				...eventProps,
			});
		},
		[track]
	);

	const trackOpenCelebrationsModal = useCallback(() => {
		track(AnalyticsEvent.Celebrations.OpenCelebrationsModal);
	}, [track]);

	return {
		trackCelebrationLinkClick,
		trackCelebrationTooltipHover,
		trackCelebrationModalLinkClick,
		trackOpenCelebrationsModal,
	};
};
